let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cXQGf")).then(() => parcelRequire('iOY2m'));